import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {
  validatePhoneHandler,
  validateOtpCodeHandler,
  resetOtpState,
  setRestrictedCodeRequired,
  setTerms,
  setTicketId,
  verifyOtpPhone,
  changePhoneInputHandler,
} from './otpAuthenticationSlice';
import {createOtpLoginStep02, setRestrictedCodeError, setOtpError} from 'app/utilities/authentication/authenticationSlice';
import {Row, Col} from 'reactstrap';
import OtpVerifyPhoneComponent from './OtpVerifyPhoneComponent';
import OtpVerifyCodeComponent from './OtpVerifyCodeComponent';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import LocalLoader from '../LocalLoader/LocalLoader';
import {otpReportData, otpCreateReport, enumGAReport, otpCreateGAReport} from './otpReports';
import EpiContext from '@episerver/spa-core/Spa';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';
import {getRecaptchaToken} from 'app/utilities/recaptcha/recaptcha';
import {rolesKeys} from 'app/Components/Block/OTPLoginBlock/Assets/variables';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';

const OtpVerificationComponent = (props) => {
  useEffect(() => {
    if (props.isAuthenticated && props.onAuthenticatedAction) {
      props.onAuthenticatedAction();
    }
  }, [props.isAuthenticated]);

  useEffect(() => {
    if (props.otp?.otpErrorPage) {
      prepareUrl(Config.otpErrorPage, EpiContext);
    }
  }, [props.otp?.otpErrorPage]);

  const handleOTPVerifyPhoneValidate = () => {
    //Google Analytics
    if (props.gaOnPhoneValidation) {
      props.gaOnPhoneValidation();
    }
    props.validatePhoneHandler({form: props.otp.otpPhoneForm}).then(function (result) {
      if (result.payload.valid) {
        otpVerifyPhone(false, true);
      }
    });
  };

  let reportData = otpReportData?.OTPPageClicked;
  let reportDataClicked = otpReportData?.OTPCodePageClicked;

  async function otpVerifyPhone() {
    const captchaToken = await getRecaptchaToken('OtpVerifyPhonePage');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }
    props.showAppLoader();
    let resPhone = await props.verifyOtpPhone({
      phoneNumber: props.otp.otpPhoneForm.phone,
      isExtended: false,
      processType: props.otpTitles.processType || '',
      otpOrigin: props.otpOrigin,
      originProcess: props.originProcess,
    });
    props.hideAppLoader();
    console.log('await ended, createOtpLoginStep1 in phone screen', resPhone);
    console.log(resPhone);
    if (resPhone.payload.Body?.isSuccess) {
      if (resPhone.payload.Body?.resultMessage === 'OTP_RESTRICT_CODE_REQUIRE') {
        props.setRestrictedCodeRequired(true);
      }
      if (resPhone.payload.Body.extra.showTerms) {
        props.setTerms(true);
      }
      props.setTicketId(resPhone.payload.Body.message);
      props.changePhoneInputHandler({target: 'phone', form: props.otp.otpPhoneForm});
    }
  }

  async function handleOTPVerifyCodeValidate() {
    //Google Analytic
    if (props.gaOnOtpCodeValidation) {
      props.gaOnOtpCodeValidation();
    }
    props.validateOtpCodeHandler({form: props.otp.otpCodeForm, processType: props.otpTitles.processType || ''}).then(function (result) {
      let restrictedCodeValid = true;
      let termsConfirmed = true;
      if (props.otp.restrictedCodeRequired && !props.otp.restrictedCodeValue) {
        restrictedCodeValid = false;
      }
      if (props.otp.termsInd && !props.otp.termsOfUseConfirmed) {
        termsConfirmed = false;
      }
      if (result.payload.valid && restrictedCodeValid && termsConfirmed) {
        submitOtpCode();
      }
    });
  }

  function reportOnClick() {
    if (props.otp?.currentStep == 'phone') {
      otpCreateReport(
        reportData.Channel,
        reportData.Area,
        reportData.SubArea,
        reportData.ActionType,
        reportData.Status,
        reportData.MessageText,
        props.otpTitles?.blockSource,
        props.otp?.otpPhoneForm?.phone,
      );
      otpCreateGAReport(enumGAReport.OtpPhoneContinueButtonClicked);
    } else if (props.otp?.currentStep == 'otp') {
      otpCreateReport(
        reportDataClicked.Channel,
        reportDataClicked.Area,
        reportDataClicked.SubArea,
        reportDataClicked.ActionType,
        reportDataClicked.Status,
        reportDataClicked.MessageText,
        props.otpTitles?.blockSource,
        props.otp?.otpPhoneForm?.phone,
      );
      otpCreateGAReport(enumGAReport.OtpClickCodePage);
    }
  }

  async function submitOtpCode() {
    props.showAppLoader();
    props.setRestrictedCodeError(null);
    props.setOtpError(null);
    await props
      .createOtpLoginStep02({
        phoneNumber: props.otp.otpPhoneForm.phone,
        otpCode: props.otp.otpCodeForm.verifyCode,
        guid: props.otp.ticketId,
        restrictCode: props.otp.restrictedCodeValue,
        termsAccepted: props.otp.termsOfUseConfirmed,
        processType: props.otpTitles.processType || '',
        otpOrigin: props.otpOrigin,
        originProcess: props.originProcess,
      })
      .then((result) => {
        if (result?.payload?.codeError == '1003') {
          props.resetOtpState();
          props.setOtpError('קוד שקיבלתם כבר לא בתוקף. כדי לשמור על הפרטים שלכם, נתחיל את התהליך מחדש');
        } else if (
          result.payload?.isSuccess == false &&
          result?.payload?.codeError != '1005' &&
          result?.payload?.codeError != '36' &&
          props.onRejectedAction
        ) {
          props.resetOtpState();
          props.onRejectedAction();
        }
      });
    props.hideAppLoader();
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  function buttonHtml() {
    return (
      <Col
        className={`${props.isInline ? 'col-4 pr-0' : 'pl-0 pr-0'} d-flex flex-wrap align-items-center otp-verification-button ${
          props.otp.otpIsLoading ? 'disabled' : ''
        }`}>
        {props.otp.reloadProcess ? (
          <BtnSubmit
            onclick={() => {
              props.resetOtpState();
            }}
            isDisplayArrows={false}
            text={'אישור'}
          />
        ) : (
          <BtnSubmit
            onclick={() => {
              !props.otp.ticketId ? handleOTPVerifyPhoneValidate() : handleOTPVerifyCodeValidate(), reportOnClick();
            }}
            isDisplayArrows={false}
            text={'המשך'}
          />
        )}
      </Col>
    );
  }

  return (
    <div className={`otp-authentication-component-main-shared `}>
      {props.otp.otpIsLoading && (
        <div className='otp-loader-wrapper'>
          <LocalLoader />
        </div>
      )}
      <form noValidate className={`otp-authentication ${props.otp.otpIsLoading ? 'loading' : ''}`} onSubmit={handleSubmit}>
        <Row className={`h-100`}>
          <Col className={`${props.isInline ? 'col-8' : 'col-12'}`}>
            {!props.otp.ticketId ? (
              <OtpVerifyPhoneComponent otpTitles={props.otpTitles} gaStep1Display={props.gaStep1Display} />
            ) : (
              <OtpVerifyCodeComponent otpTitles={props.otpTitles} otpVerifyPhone={otpVerifyPhone} gaStep2Display={props.gaStep2Display} />
            )}
          </Col>
          {props.isInline && buttonHtml()}
        </Row>
        {!props.isInline && <Row className='opt-button-notInline'>{buttonHtml()}</Row>}
      </form>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {isOtpAuthenticated, isFullAuthenticated, isOtpExtendedAuthenticated, isSilentOtpAuthenticated} = state.authentication.loginData;

  return {
    otp: state.otpAuthentication,
    isAuthenticated: isOtpAuthenticated || isFullAuthenticated || isOtpExtendedAuthenticated || isSilentOtpAuthenticated,
  };
};

const mapDispatchToProps = {
  validatePhoneHandler,
  validateOtpCodeHandler,
  resetOtpState,
  setRestrictedCodeRequired,
  setTerms,
  setTicketId,
  verifyOtpPhone,
  changePhoneInputHandler,
  createOtpLoginStep02,
  hideAppLoader,
  showAppLoader,
  setRestrictedCodeError,
  setOtpError,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerificationComponent);
